var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgQuickEasyShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M59.902 18.5c.1-1.1-.8-2-1.9-2h-.4l-4 .8c-.4.1-.7-.2-.7-.6v-4h.3c.7 0 1.2-.5 1.2-1.2V11c0-.7-.5-1.2-1.2-1.2h-.5c-.7 0-1.3-.2-1.9-.5-4-2.1-9.9-3.6-16.5-4.1-.5 0-.9-.2-1.3-.4-.7-.4-.4-1.5.4-1.5h.4c.7 0 1.3-.6 1.3-1.3v-.4c0-.7-.6-1.3-1.3-1.3h-7.6c-.7 0-1.3.6-1.3 1.3V2c0 .7.6 1.3 1.3 1.3h.4c.8 0 1.2 1.1.5 1.5-.4.2-.8.4-1.3.4-6.6.5-12.4 1.9-16.5 4.1-.6.3-1.2.5-1.9.5h-.5c-.7 0-1.2.5-1.2 1.2v.5c0 .7.5 1.2 1.2 1.2h.3v4c0 .4-.3.7-.7.6l-4-.8h-.4c-.9 0-1.7.6-1.9 1.5-.1.5 0 1 .3 1.4.3.4.7.7 1.2.8l4.3.9c.7.2 1.3.8 1.3 1.6v12.8c0 3.3 2.7 6 6 6h33.7c3.3 0 6-2.7 6-6V22.7c0-.8.5-1.4 1.3-1.5l4.2-.9c.6-.2 1.3-.9 1.4-1.8zm-13.1 20.3h-33.6c-1.8 0-3.3-1.5-3.3-3.3V14.4c0-.7.5-1.2 1.2-1.2h37.8c.7 0 1.2.5 1.2 1.2v21.1c0 1.9-1.5 3.3-3.3 3.3z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--quick-easy-shadow-fe055d606c8840afa811fb1ee60fd65c.svg";
export { SvgIconMktgQuickEasyShadow as Component };